module.exports = ".MerchInfo_modal{max-width:480px}.MerchInfo_modal>*:first-child{margin-top:0}\n"